<span class="eb-order-detail-documents__table-download-button-wrapper">
  <button (click)="downloadDocument()" class="eb-order-detail-documents__table-download-button">
    <em class="fas fa-download"></em>
  </button>
</span>
